import { render, staticRenderFns } from "./Cultive.vue?vue&type=template&id=e146eff4"
import script from "./Cultive.vue?vue&type=script&lang=js"
export * from "./Cultive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports